var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { Component } from 'vue-property-decorator';
import GoodService from "../../api/GoodService";
import DeliverService from '../../api/DeliverService';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import BindLicensesHeader from "./components/BindLicensesHeader.vue";
import viewImgList from '../shopAfterSales/components/viewImgList';
import UploadLicenseDialog from './components/UploadLicenseDialog.vue';
import LicenseService from "../../api/LicenseService";
var SeeBindLicenses = (function (_super) {
    __extends(SeeBindLicenses, _super);
    function SeeBindLicenses() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.from_page = '';
        _this.order_id = '';
        _this.order_detail_id = '';
        _this.goods_id = '';
        _this.goods_name = '';
        _this.goods_code = '';
        _this.goods_format_id = '';
        _this.goods_format_name = '';
        _this.tableHeight = 300;
        _this.tableData = [];
        _this.selectedDatas = {};
        _this.selectedData = [];
        _this.specifyFormat = false;
        _this.specifyDeliver = false;
        _this.isBindSupplierGoodsId = true;
        _this.IsEditOrderDocument = false;
        _this.viewImgData = [];
        _this.viewImgDefaultIndex = 0;
        return _this;
    }
    SeeBindLicenses.prototype.created = function () {
        this.service = GoodService.getInstance();
        this.deliverService = DeliverService.getInstance();
        this.licenseService = LicenseService.getInstance();
        this.specifyFormat = this.goods_format_id ? true : false;
        this.specifyDeliver = this.from_page == 'deliver';
        this.isBindSupplierGoodsId = this.supplier_goods_id ? true : false;
        console.log(11, this.goods_format_name);
        this.IsEditOrderDocument = this.is_edit_order_document == 1;
    };
    SeeBindLicenses.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 160 - 40;
            }
        }, 300);
    };
    SeeBindLicenses.prototype.deleteLicence = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请先选中证照");
            return;
        }
        this.$confirm("删除后对应证照不再同步到客户系统且不可恢复，确定删除吗？").then(function () {
            var document_data = _this.selectedData.map(function (v) {
                var resetV = {
                    document_id: v.document_id,
                    type: v.document_type
                };
                return resetV;
            });
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.licenseService
                .licenseOrderDelete({
                data: JSON.stringify(document_data)
            })
                .then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg || '删除成功');
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message);
            });
        });
    };
    SeeBindLicenses.prototype.uploadLicence = function () {
        var _this = this;
        var instance = this.$dialog(UploadLicenseDialog, {
            data: {
                delivery_order_id: this.order_id,
                delivery_order_detail_id: this.order_detail_id,
            }
        }, {
            title: "上传证照",
            width: 640,
        }).instance;
        instance.$on("upload_liscense:ok", function () {
            _this.getList();
        });
    };
    SeeBindLicenses.prototype.selectionChangeAll = function (val, index) {
        var _this = this;
        this.selectedDatas[index] = val;
        var arr = [];
        Object.keys(this.selectedDatas).map(function (key) {
            if (_this.selectedDatas[key].length)
                arr = arr.concat(_this.selectedDatas[key]);
        });
        this.selectedData = arr;
    };
    SeeBindLicenses.prototype.search = function (filter) {
        this.filter = filter;
        this.getList();
    };
    SeeBindLicenses.prototype.getList = function () {
        if (this.specifyDeliver) {
            this.getDeliverGoodsLicenses();
        }
        else {
            this.getCommonGoodsLicenses();
        }
    };
    SeeBindLicenses.prototype.getCommonGoodsLicenses = function () {
        var _this = this;
        var params = {
            goods_id: this.goods_id
        };
        Object.assign(params, this.filter);
        if (this.goods_format_id) {
            params.goods_format_id = this.goods_format_id;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getGoodAlreadyBindLicenses(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.tableData = res.data.data;
                window._czc.push(["_trackEvent", '货品管理', '查看绑定证照']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    SeeBindLicenses.prototype.syncOrderDocument = function () {
        var _this = this;
        var filter = this.filter;
        var params = {
            delivery_order_id: this.order_id,
            order_detail_id: this.order_detail_id,
        };
        this.deliverService.syncOrderDocument(params).then(function (res) {
            if (res.data.success) {
                _this.$message.success(res.data.msg);
                _this.search(filter);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    SeeBindLicenses.prototype.getDeliverGoodsLicenses = function () {
        var _this = this;
        var params = {
            order_detail_id: this.order_detail_id,
            goods_format_id: this.goods_format_id,
            business_id: this.business_id
        };
        Object.assign(params, this.filter);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.licenseService.getLicenseOrderList(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.tableData = [res.data.data];
                window._czc.push(["_trackEvent", '送货单', '查看绑定货品证照']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    SeeBindLicenses.prototype.unBindLicenses = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择证照");
            return;
        }
        var document_ids = this.selectedData.map(function (v) { return v.document_id; });
        var goods_format_ids = this.selectedData.map(function (v) { return v.goods_format_id; });
        var params = {
            goods_id: this.goods_id,
            goods_format_ids: goods_format_ids.join(','),
            document_ids: document_ids.join(',')
        };
        var html = "<div>\u786E\u5B9A\u8981\u89E3\u7ED1\u4EE5\u4E0B\u8BC1\u7167\u5417\uFF1F<br/> " + this.selectedData.map(function (v) { return v.document_name; }).join('<br/>') + "</div>";
        this.$confirm(html, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'message-h-40vh'
        }).then(function (result) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.goodUnBindLicenses(params).then(function (res) {
                loadingInstance.close();
                if (res.data.success) {
                    _this.$message.success("解绑成功");
                    _this.getList();
                    window._czc.push(["_trackEvent", '货品管理', '解绑证照']);
                    if (!_this.specifyFormat) {
                        if (_this.opener) {
                            _this.opener.search();
                        }
                    }
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            console.log(err);
        });
    };
    SeeBindLicenses.prototype.changeViewImgIndex = function (index, data) {
        var _this = this;
        this.viewImgData = data;
        this.viewImgDefaultIndex = index;
        this.$nextTick(function () {
            _this.$refs.viewImgList.show();
        });
    };
    SeeBindLicenses = __decorate([
        auth(nameDict["货品档案"], true),
        Component({
            components: {
                'list-header': BindLicensesHeader,
                viewImgList: viewImgList
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData'
            })),
        })
    ], SeeBindLicenses);
    return SeeBindLicenses;
}(Vue));
export default SeeBindLicenses;
